import { integrationTestInstance } from '../axios';

const getBillingInvoiceProcessResult = (invoiceId: any) => 
  integrationTestInstance.post('/integration/billing/invoice-status', { invoiceId });
const resendBillingInvoiceProcess = (invoiceId: any) => 
  integrationTestInstance.post('/integration/billing/invoice-resend', { invoiceId });

export default {
  getBillingInvoiceProcessResult,
  resendBillingInvoiceProcess,
};